/**
 * 自动生成， 请不要手工修改！
 */

import {AbstractSerializable} from '../../serialize/AbstractJsonSerializable'
import {JsonTypeTagType} from '../../serialize/JsonTypeTagType'
import {PlatformOffer} from '../../datatype/platform/offer/PlatformOffer'
import {Serializer} from '../../serialize/Serializer'
import {ServiceError} from '../../common/ServiceError'
import {ServiceRequestStatusType} from './ServiceRequestStatusType'
import {ServiceResponseHandle} from './ServiceResponseHandle'
import {TypeFactory} from '../../serialize/TypeFactory'


export abstract class AbstractSimpleServiceResponseHandle<T> extends AbstractSerializable implements ServiceResponseHandle<T> {
    result: T;
    error: ServiceError;
    workflowId: string;
    inWorkflow: boolean;
    platformOffer: PlatformOffer;

    constructor() {
        super();
    }

    public getResult(): T {
        return this.result;
    }

    public setResult(result: T) {
        this.result = result;
    }

    public getError(): ServiceError {
        return this.error;
    }

    public setError(error: ServiceError) {
        this.error = error;
    }

    public getWorkflowId(): string {
        return this.workflowId;
    }

    public setWorkflowId(workflowId: string) {
        this.workflowId = workflowId;
    }

    public isInWorkflow(): boolean {
        return this.inWorkflow;
    }

    public setInWorkflow(inWorkflow: boolean) {
        this.inWorkflow = inWorkflow;
    }

    public getPlatformOffer(): PlatformOffer {
        return this.platformOffer;
    }

    public setPlatformOffer(platformOffer: PlatformOffer) {
        this.platformOffer = platformOffer;
    }


    abstract getStatusType(): ServiceRequestStatusType;


    public fillFromJson(json: Object, factory?: TypeFactory) {
        let result = json["result"];
        if (result != null) {
            let convertedResult0 = Serializer.fromJson(result, factory);
            this.setResult(convertedResult0);
        }
        let error = json["error"];
        if (error != null) {
            let convertedError0 = new ServiceError();
            convertedError0.fillFromJson(error, factory);
            this.setError(convertedError0);
        }
        let workflowId = json["workflowId"];
        if (workflowId != null) {
            this.setWorkflowId(workflowId);
        }
        let inWorkflow = json["inWorkflow"];
        if (inWorkflow != null) {
            this.setInWorkflow(inWorkflow);
        }
        let platformOffer = json["platformOffer"];
        if (platformOffer != null) {
            let convertedPlatformOffer0 = new PlatformOffer();
            convertedPlatformOffer0.fillFromJson(platformOffer, factory);
            this.setPlatformOffer(convertedPlatformOffer0);
        }
    }

    public fillToJson(json: Object, includeTypeTag: boolean = true) {
        let result = this.getResult();
        if (result != null) {
            let convertedResult0 = Serializer.getJson(result, JsonTypeTagType.CLASS);
            json["result"] = convertedResult0;
        }
        let error = this.getError();
        if (error != null) {
            let convertedError0 = error.getJson(JsonTypeTagType.NONE);
            json["error"] = convertedError0;
        }
        let workflowId = this.getWorkflowId();
        if (workflowId != null) {
            json["workflowId"] = workflowId;
        }
        let inWorkflow = this.isInWorkflow();
        if (inWorkflow != null) {
            json["inWorkflow"] = inWorkflow;
        }
        let platformOffer = this.getPlatformOffer();
        if (platformOffer != null) {
            let convertedPlatformOffer0 = platformOffer.getJson(JsonTypeTagType.NONE);
            json["platformOffer"] = convertedPlatformOffer0;
        }

        if (includeTypeTag) {
            json["__type"] = "SimpleServiceResponseHandle";
        }
    }


    public getTypeId(): string {
        return "SimpleServiceResponseHandle";
    }

    public getClassName(): string {
        return "com.gong_wei.service.api.datatype.SimpleServiceResponseHandle";
    }
}
